import React, { useState, useEffect } from 'react';
import GetMonths from '../../Dropdowns/getMonths';
import GetYears from '../../Dropdowns/getYears';
import AnnavitranSaleReport from './AnnavitranSaleReport';

const AnnavitranSale = ({ heading }) => {

    const [renderContent, setRenderContent] = useState(null);
    const [loadingMonths, setLoadingMonths] = useState(true); 
    const [loadingYears, setLoadingYears] = useState(true);   
 
     useEffect(() => {
        if (!loadingMonths && !loadingYears) {

            const timer = setTimeout(() => {
                handleSubmit();
            }, 100);

             return () => clearTimeout(timer);

        }

    }, [loadingMonths, loadingYears, 100]); // Only run when loading states change

     const handleMonthsLoadingChange = (isLoading) => {
        setLoadingMonths(isLoading);
    };

     const handleYearsLoadingChange = (isLoading) => {
        setLoadingYears(isLoading);
    };

    const handleSubmit = () => {
        const month = document.getElementById('month').value;
        const year = document.getElementById('year').value;
       
        if (month==0 || month == null || month ==''  ) {
            alert('Please select Month');
        } else if (year==0 || year == null || year ==''  ) {
            alert('Please select Year');
        }  else {
            setRenderContent(null);

            setTimeout(() => {
                setRenderContent(
                    <AnnavitranSaleReport
                        month={month} 
                        year={year} 
                        heading={heading} />
                );
            }, 0);
                }
    }; 
     
    return (
        
        <>
            <div className="wrapper row3">
                <div id="container">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <table width="30%">
                            <thead>
                                <tr className="tableheader">
                                    <th colSpan={8}>{heading}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td>Month</td>
                                    <td><GetMonths onLoadingChange={handleMonthsLoadingChange} /></td>
                                    <td>Year</td>
                                    <td><GetYears onLoadingChange={handleYearsLoadingChange} /></td>
                                      </tr>
                                <tr>
                                    <td colSpan={8} align="center">
                                    <button onClick={handleSubmit} className="button button2" disabled={loadingMonths || loadingYears}>
                                            Submit
                                        </button>
                                        <button className="button button2">
                                            Back
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <div id="loading" style={{ display: 'none', textAlign: 'center' }}>
                        <img src="images/progress.gif" alt="Loading" />
                    </div>
                    <br />
                    {/* Render the dynamic content here */}
                    <div id="details1">{renderContent}</div>
                </div>
            </div>
        </>
    );
};

export default AnnavitranSale; 
